export default __webpack_public_path__ + "static/media/check2.a6e7e8a5.svg";